module.exports = __webpack_public_path__ + "img/grand_diamond.993e6006.png";